import React, { useState } from "react";
import { Layout, Dropdown, Avatar } from "antd";
import {
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
// import "./Header.css";
import './style.css';
import logo from '../assets/InteliquantLogo.png';

const { Header } = Layout;

const HeaderBar = ({ onToggleSidebar }) => {
  const [open, setOpen] = useState(false);

  const user = {
    name: "Himanshu",
    role: "Admin",
  };

const handleLogout = () => {
  localStorage.removeItem("isAuthenticated");
  window.location.href = "/login"; // hard redirect
};

  const menuItems = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  return (
    <Header className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-4 md:px-6 h-16 shadow-md header-main">
      
      {/* LEFT SECTION */}
      <div className="flex items-center gap-3">
        
        {/* Mobile Menu Button */}
        <button
          onClick={onToggleSidebar}
          className="lg:hidden text-white text-xl"
        >
          ☰
        </button>

        {/* Logo */}
        <img src={logo} alt="logo" className="h-8 md:h-9 object-contain" />
      </div>

      {/* RIGHT SECTION */}
      <div className="flex items-center gap-3 md:gap-4">

        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          open={open}
          onOpenChange={setOpen}
        >
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <Avatar icon={<UserOutlined />} />

            {/* Hide on mobile */}
            <div className="hidden md:flex flex-col leading-tight">
              <span className="text-white text-sm font-semibold">
                {user.name}
              </span>
              <span className="text-white text-xs opacity-70">
                {user.role}
              </span>
            </div>

            <SettingOutlined className="text-white text-sm" />
          </motion.div>
        </Dropdown>
      </div>
    </Header>
  );
};

export default HeaderBar;